const routes = {
  epsList: (): string => `eps`,
};

export default routes;
